import React from "react"

import { useSelector } from "react-redux"

import { SettingsSBP } from "../../../../pages/SettingsSBP"

import { RootState } from "../../../../store/store"
import { settingsSBPSteps } from "../../../../store/slices/routingSlice/flowsSteps"
import UpdateDefaultBank from "../../../../pages/UpdateDefaultBank"
import { UpdateDefaultBankRequestAction } from "../../../../api/interface"
import UpdateDefaultBankSuccess from "../../../../pages/UpdateDefaultBankSuccess"
import UpdateDefaultBankFail from "../../../../pages/UpdateDefaultBankFail"

const DefaultBankFlow = () => {
  const currentStep = useSelector(
    (state: RootState) => state.routing.routes.settingsSBP.currentStep,
  )
  const phoneNumber = useSelector(
    (state: RootState) => state.auth.phoneNumber
  )

  switch (currentStep) {
    case settingsSBPSteps.sbpSettings.name: {
      return <SettingsSBP />
    }

    case settingsSBPSteps.setDefaultBank.name: {
      return <UpdateDefaultBank phoneNumber={phoneNumber} action={UpdateDefaultBankRequestAction.SET}/>
    }
    case settingsSBPSteps.setDefaultBankSuccess.name: {
      return <UpdateDefaultBankSuccess action={UpdateDefaultBankRequestAction.SET}/>
    }
    case settingsSBPSteps.setDefaultBankFail.name: {
      return <UpdateDefaultBankFail/>
    }
    case settingsSBPSteps.deleteDefaultBank.name: {
      return <UpdateDefaultBank phoneNumber={phoneNumber} action={UpdateDefaultBankRequestAction.DELETE}/>
    }
    case settingsSBPSteps.deleteDefaultBankSuccess.name: {
      return <UpdateDefaultBankSuccess action={UpdateDefaultBankRequestAction.DELETE}/>
    }
    case settingsSBPSteps.deleteDefaultBankFail.name: {
      return <UpdateDefaultBankFail/>
    }

    default: {
      return <SettingsSBP />
    }
  }
}

export default DefaultBankFlow
